var _a;
import { createSlice } from '@reduxjs/toolkit';
import { name } from './constants';
var initialState = {
    data: [],
    loading: 'idle',
    error: null,
};
export var tournamentsList = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        resetTournaments: function () {
            return initialState;
        },
        getTournamentsListPending: function (state) {
            state.loading = 'pending';
            state.error = null;
        },
        getTournamentsListSuccess: function (state, _a) {
            var payload = _a.payload;
            state.loading = 'fulfilled';
            state.data = payload;
        },
        getTournamentsListError: function (state, _a) {
            var payload = _a.payload;
            state.loading = 'rejected';
            state.error = payload;
        },
    },
});
export var resetTournaments = (_a = tournamentsList.actions, _a.resetTournaments), getTournamentsListPending = _a.getTournamentsListPending, getTournamentsListSuccess = _a.getTournamentsListSuccess, getTournamentsListError = _a.getTournamentsListError;
